"use strict";
exports.__esModule = true;
exports.getAttributesDisplayForms = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var GdcVisualizationObject_1 = require("./GdcVisualizationObject");
var isAttribute = GdcVisualizationObject_1.GdcVisualizationObject.isAttribute;
var isMeasure = GdcVisualizationObject_1.GdcVisualizationObject.isMeasure;
var isAttributeFilter = GdcVisualizationObject_1.GdcVisualizationObject.isAttributeFilter;
function getAttributesInBucket(bucket) {
    return bucket.items.reduce(function (list, bucketItem) {
        if (isAttribute(bucketItem)) {
            list.push(bucketItem.visualizationAttribute);
        }
        return list;
    }, []);
}
function getAttributes(mdObject) {
    var buckets = mdObject.buckets;
    return buckets.reduce(function (categoriesList, bucket) {
        categoriesList.push.apply(categoriesList, getAttributesInBucket(bucket));
        return categoriesList;
    }, []);
}
function getMeasuresInBucket(bucket) {
    return bucket.items.reduce(function (list, bucketItem) {
        if (isMeasure(bucketItem)) {
            list.push(bucketItem.measure);
        }
        return list;
    }, []);
}
function getDefinition(measure) {
    return GdcVisualizationObject_1.GdcVisualizationObject.isMeasureDefinition(measure.definition)
        ? measure.definition.measureDefinition
        : undefined;
}
function getMeasures(mdObject) {
    var buckets = mdObject.buckets;
    return buckets.reduce(function (measuresList, bucket) {
        measuresList.push.apply(measuresList, getMeasuresInBucket(bucket));
        return measuresList;
    }, []);
}
function getMeasureFilters(measure) {
    var _a, _b;
    return (_b = (_a = getDefinition(measure)) === null || _a === void 0 ? void 0 : _a.filters) !== null && _b !== void 0 ? _b : [];
}
function getMeasureAttributeFilters(measure) {
    return getMeasureFilters(measure).filter(isAttributeFilter);
}
function getAttributeFilters(mdObject) {
    return getMeasures(mdObject).reduce(function (filters, measure) {
        filters.push.apply(filters, getMeasureAttributeFilters(measure));
        return filters;
    }, []);
}
function getAttributeFilterDisplayForm(measureFilter) {
    return GdcVisualizationObject_1.GdcVisualizationObject.isPositiveAttributeFilter(measureFilter)
        ? measureFilter.positiveAttributeFilter.displayForm.uri
        : measureFilter.negativeAttributeFilter.displayForm.uri;
}
/**
 * @public
 */
function getAttributesDisplayForms(mdObject) {
    var attributesDfs = getAttributes(mdObject).map(function (attribute) {
        return attribute.displayForm.uri;
    });
    var attrMeasureFilters = getAttributeFilters(mdObject);
    var attrMeasureFiltersDfs = attrMeasureFilters.map(getAttributeFilterDisplayForm);
    return tslib_1.__spreadArrays(attrMeasureFiltersDfs, attributesDfs);
}
exports.getAttributesDisplayForms = getAttributesDisplayForms;
//# sourceMappingURL=utils.js.map